import { BaseExportStrategy } from "./BaseExportStrategy";
import { IExportStrategyConfig } from "./types";

export class InternalExportStrategy extends BaseExportStrategy {
  getConfig(): IExportStrategyConfig {
    return {
      carriersEndpoint: "carriers_clients?getAll=true",
      ordersEndpoint: "internal",
      filesEndpoint: "/internal/files",
      summaryEndpoint: "/internal/summary",
      needsMerchants: false,
      needsAliases: false,
      needsMarketplaceId: false,
      needsClients: true,
    };
  }
}
